import MainNavigation from './modules/MainNavigation';
import Main from './pages/Main';
import { AuthProvider } from './utils/auth';
import { ActiviteitenProvider } from './utils/activiteiten';
import './css/baseStyling.css';

function App() {


  return (
    <div className="App">
      <AuthProvider>
        <ActiviteitenProvider>

          <MainNavigation />
          <Main />

        </ActiviteitenProvider>
      </AuthProvider>
      
    </div>
  );
}

export default App;
